"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable: max-classes-per-file

var web3_subprovider_1 = __importDefault(require("@walletconnect/web3-subprovider"));

var events_1 = __importDefault(require("events"));

var web3_provider_engine_1 = __importDefault(require("web3-provider-engine"));

var rpc_1 = __importDefault(require("web3-provider-engine/subproviders/rpc")); // tslint:disable-line: no-submodule-imports


var libraries_1 = require("./libraries");

function ErrorCodeMixin(Base, errorCodes) {
  return (
    /** @class */
    function (_super) {
      __extends(class_1, _super);

      function class_1(kwargs) {
        if (kwargs === void 0) {
          kwargs = {};
        }

        return _super.call(this, kwargs) || this;
      }

      Object.defineProperty(class_1, "errorCodes", {
        get: function get() {
          return errorCodes.reduce(function (accumulator, currentValue) {
            accumulator[currentValue] = currentValue;
            return accumulator;
          }, {});
        },
        enumerable: true,
        configurable: true
      });
      return class_1;
    }(Base)
  );
}

exports.ErrorCodeMixin = ErrorCodeMixin;
var ConnectorErrorCodes = ['UNSUPPORTED_NETWORK'];

var Connector =
/** @class */
function (_super) {
  __extends(Connector, _super);

  function Connector(kwargs) {
    if (kwargs === void 0) {
      kwargs = {};
    }

    var _this = _super.call(this) || this;

    var supportedNetworks = kwargs.supportedNetworks;
    _this.supportedNetworks = supportedNetworks;
    _this.active = false;
    return _this;
  }

  Connector.prototype.onActivation = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.active = true;
        this.emit('Activated');
        return [2
        /*return*/
        ];
      });
    });
  };

  Connector.prototype.onDeactivation = function () {
    this.emit('Deactivated');
    this.active = false;
  };

  Connector.prototype.validateNetworkId = function (networkId) {
    if (this.supportedNetworks && !this.supportedNetworks.includes(networkId)) {
      var unsupportedNetworkError = Error("Unsupported Network: " + networkId + ".");
      unsupportedNetworkError.code = Connector.errorCodes.UNSUPPORTED_NETWORK;
      throw unsupportedNetworkError;
    }

    return networkId;
  }; // wraps emissions of _web3ReactUpdateNetworkId


  Connector.prototype._web3ReactUpdateNetworkIdHandler = function (networkId) {
    this.emit('_web3ReactUpdateNetworkId', networkId);
  }; // wraps emissions of _web3ReactUpdateAccount


  Connector.prototype._web3ReactUpdateAccountHandler = function (account) {
    this.emit('_web3ReactUpdateAccount', account);
  }; // wraps emissions of _web3ReactUpdateNetworkIdAndAccount


  Connector.prototype._web3ReactUpdateNetworkIdAndAccountHandler = function (networkId, account) {
    this.emit('_web3ReactUpdateNetworkIdAndAccount', networkId, account);
  }; // wraps emissions of _web3ReactError


  Connector.prototype._web3ReactErrorHandler = function (error) {
    this.emit('_web3ReactError', error);
  }; // wraps emissions of _web3ReactError


  Connector.prototype._web3ReactResetHandler = function () {
    this.emit('_web3ReactReset');
  };

  return Connector;
}(ErrorCodeMixin(events_1.default, ConnectorErrorCodes));

exports.Connector = Connector;
var MetaMaskConnectorErrorCodes = ['ETHEREUM_ACCESS_DENIED', 'LEGACY_PROVIDER', 'NO_WEB3', 'UNLOCK_REQUIRED'];

var MetaMaskConnector =
/** @class */
function (_super) {
  __extends(MetaMaskConnector, _super);

  function MetaMaskConnector(kwargs) {
    if (kwargs === void 0) {
      kwargs = {};
    }

    var _this = _super.call(this, kwargs) || this;

    _this.runOnDeactivation = [];
    _this.networkChangedHandler = _this.networkChangedHandler.bind(_this);
    _this.accountsChangedHandler = _this.accountsChangedHandler.bind(_this);
    return _this;
  }

  MetaMaskConnector.prototype.onActivation = function () {
    return __awaiter(this, void 0, void 0, function () {
      var ethereum, web3, legacyError, noWeb3Error;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.onActivation.call(this)];

          case 1:
            _a.sent();

            ethereum = window.ethereum, web3 = window.web3;
            if (!ethereum) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , ethereum.enable().catch(function (error) {
              var deniedAccessError = Error("Access Denied: " + error.toString() + ".");
              deniedAccessError.code = MetaMaskConnector.errorCodes.ETHEREUM_ACCESS_DENIED;
              throw deniedAccessError;
            }) // initialize event listeners
            ];

          case 2:
            _a.sent(); // initialize event listeners


            if (ethereum.on && ethereum.removeListener) {
              ethereum.on('networkChanged', this.networkChangedHandler);
              ethereum.on('accountsChanged', this.accountsChangedHandler);
              this.runOnDeactivation.push(function () {
                ethereum.removeListener('networkChanged', _this.networkChangedHandler);
                ethereum.removeListener('accountsChanged', _this.accountsChangedHandler);
              });
            } else {
              // tslint:disable-next-line: no-console
              console.error("The injected 'ethereum' object does not support the appropriate listener methods.");
            }

            return [3
            /*break*/
            , 4];

          case 3:
            if (web3) {
              legacyError = Error('Your web3 provider is outdated, please upgrade to a modern provider.');
              legacyError.code = MetaMaskConnector.errorCodes.LEGACY_PROVIDER;
              throw legacyError;
            } else {
              noWeb3Error = Error('Your browser is not equipped with web3 capabilities.');
              noWeb3Error.code = MetaMaskConnector.errorCodes.NO_WEB3;
              throw noWeb3Error;
            }

            _a.label = 4;

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  MetaMaskConnector.prototype.getLibrary = function (libraryName) {
    return __awaiter(this, void 0, void 0, function () {
      var ethereum;
      return __generator(this, function (_a) {
        ethereum = window.ethereum;
        return [2
        /*return*/
        , libraries_1.getNewLibraryFromProvider(libraryName, ethereum)];
      });
    });
  };

  MetaMaskConnector.prototype.getNetworkId = function (library) {
    return __awaiter(this, void 0, void 0, function () {
      var networkId;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , libraries_1.getNetworkId(library)];

          case 1:
            networkId = _a.sent();
            return [2
            /*return*/
            , this.validateNetworkId(networkId)];
        }
      });
    });
  };

  MetaMaskConnector.prototype.getAccount = function (library) {
    return __awaiter(this, void 0, void 0, function () {
      var accounts, unlockRequiredError;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , libraries_1.getAccounts(library)];

          case 1:
            accounts = _a.sent();

            if (!accounts || !accounts[0]) {
              unlockRequiredError = Error('Ethereum account locked.');
              unlockRequiredError.code = MetaMaskConnector.errorCodes.UNLOCK_REQUIRED;
              throw unlockRequiredError;
            }

            return [2
            /*return*/
            , accounts[0]];
        }
      });
    });
  };

  MetaMaskConnector.prototype.onDeactivation = function () {
    this.runOnDeactivation.forEach(function (runner) {
      return runner();
    });
    this.runOnDeactivation = [];
  }; // metamask event handlers


  MetaMaskConnector.prototype.networkChangedHandler = function (networkId) {
    this._web3ReactUpdateNetworkIdHandler(networkId);
  };

  MetaMaskConnector.prototype.accountsChangedHandler = function (accounts) {
    this._web3ReactUpdateAccountHandler(accounts[0]);
  };

  return MetaMaskConnector;
}(ErrorCodeMixin(Connector, MetaMaskConnectorErrorCodes));

exports.MetaMaskConnector = MetaMaskConnector;

var WalletConnectConnector =
/** @class */
function (_super) {
  __extends(WalletConnectConnector, _super);

  function WalletConnectConnector(kwargs) {
    var _this = this;

    var bridge = kwargs.bridge,
        supportedNetworkURLs = kwargs.supportedNetworkURLs,
        defaultNetwork = kwargs.defaultNetwork;
    var supportedNetworks = Object.keys(supportedNetworkURLs).map(function (supportedNetworkURL) {
      return Number(supportedNetworkURL);
    });
    _this = _super.call(this, {
      supportedNetworks: supportedNetworks
    }) || this;
    _this.supportedNetworkURLs = supportedNetworkURLs;
    _this.defaultNetwork = defaultNetwork;
    var walletConnectSubprovider = new web3_subprovider_1.default({
      bridge: bridge
    });
    _this.walletConnectSubprovider = walletConnectSubprovider;
    _this.walletConnector = _this.walletConnectSubprovider._walletConnector;
    _this.connectAndSessionUpdateHandler = _this.connectAndSessionUpdateHandler.bind(_this);
    _this.disconnectHandler = _this.disconnectHandler.bind(_this);
    return _this;
  }

  WalletConnectConnector.prototype.onActivation = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , _super.prototype.onActivation.call(this)];

          case 1:
            _a.sent();

            if (!!this.walletConnector.connected) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.walletConnector.createSession()];

          case 2:
            _a.sent();

            _a.label = 3;

          case 3:
            this.uri = this.walletConnector.uri; // initialize event listeners

            this.walletConnector.on('connect', this.connectAndSessionUpdateHandler);
            this.walletConnector.on('session_update', this.connectAndSessionUpdateHandler);
            this.walletConnector.on('disconnect', this.disconnectHandler);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  WalletConnectConnector.prototype.getLibrary = function (libraryName, networkId) {
    return __awaiter(this, void 0, void 0, function () {
      var networkIdToUse, engine;
      return __generator(this, function (_a) {
        // this should never happened, because it probably means there was a funky walletconnect race condition
        if (networkId && this.walletConnector.chainId && networkId !== this.walletConnector.chainId) {
          throw Error('Unexpected Error. Please file an issue on Github.');
        }

        networkIdToUse = this.walletConnector.chainId || networkId || this.defaultNetwork;

        if (networkIdToUse) {
          try {
            this.validateNetworkId(networkIdToUse);
          } catch (error) {
            throw error;
          }
        }

        engine = new web3_provider_engine_1.default();
        engine.addProvider(this.walletConnectSubprovider);
        engine.addProvider(new rpc_1.default({
          rpcUrl: this.supportedNetworkURLs[networkIdToUse]
        }));
        engine.start();
        return [2
        /*return*/
        , libraries_1.getNewLibraryFromProvider(libraryName, engine)];
      });
    });
  };

  WalletConnectConnector.prototype.getNetworkId = function (library) {
    return __awaiter(this, void 0, void 0, function () {
      var networkId;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , libraries_1.getNetworkId(library)];

          case 1:
            networkId = _a.sent();
            return [2
            /*return*/
            , this.validateNetworkId(networkId)];
        }
      });
    });
  };

  WalletConnectConnector.prototype.getAccount = function (library) {
    return __awaiter(this, void 0, void 0, function () {
      var accounts;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.walletConnector.connected) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , libraries_1.getAccounts(library)];

          case 1:
            accounts = _a.sent();

            if (!accounts || !accounts[0]) {
              throw Error('No accounts found.');
            }

            return [2
            /*return*/
            , accounts[0]];

          case 2:
            return [2
            /*return*/
            , null];
        }
      });
    });
  };

  WalletConnectConnector.prototype.onDeactivation = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        ];
      });
    });
  }; // walletconnect event handlers


  WalletConnectConnector.prototype.connectAndSessionUpdateHandler = function (error, payload) {
    if (error) {
      this._web3ReactErrorHandler(error);
    } else {
      var _a = payload.params[0],
          chainId = _a.chainId,
          accounts = _a.accounts;

      this._web3ReactUpdateNetworkIdAndAccountHandler(chainId, accounts[0]);
    }
  };

  WalletConnectConnector.prototype.disconnectHandler = function (error) {
    if (error) {
      this._web3ReactErrorHandler(error);
    } else {
      this._web3ReactResetHandler();
    }
  };

  return WalletConnectConnector;
}(Connector);

exports.WalletConnectConnector = WalletConnectConnector;

var NetworkOnlyConnector =
/** @class */
function (_super) {
  __extends(NetworkOnlyConnector, _super);

  function NetworkOnlyConnector(kwargs) {
    var _this = this;

    var providerURL = kwargs.providerURL,
        rest = __rest(kwargs, ["providerURL"]);

    _this = _super.call(this, rest) || this;
    _this.providerURL = providerURL;
    return _this;
  }

  NetworkOnlyConnector.prototype.getLibrary = function (libraryName) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , libraries_1.getNewLibraryFromURL(libraryName, this.providerURL)];
      });
    });
  };

  NetworkOnlyConnector.prototype.getNetworkId = function (library) {
    return __awaiter(this, void 0, void 0, function () {
      var networkId;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , libraries_1.getNetworkId(library)];

          case 1:
            networkId = _a.sent();
            return [2
            /*return*/
            , this.validateNetworkId(networkId)];
        }
      });
    });
  };

  NetworkOnlyConnector.prototype.getAccount = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , null];
      });
    });
  };

  return NetworkOnlyConnector;
}(Connector);

exports.NetworkOnlyConnector = NetworkOnlyConnector;